var locales = {
  'en': {
    'topFolder': {
      'projectFiles': 'Project Files',
      'forTheField': 'For the Field'
    },
    'permissions': {
      'everyone': 'Everyone'
    },
    'attributes': {
      'title': 'Title',
      'number': 'Number',
      'sheetNumber': 'Sheet number',
      'project': 'Project',
      'originator': 'Originator',
      'volumeSystem': 'Volume/System',
      'levelLocation': 'Level/Location',
      'type': 'Type',
      'role': 'Role',
      'status': 'Status',
      'revision': 'Revision',
      'classification': 'Classification'
    },
    'users': {
      'accSystem': 'ACC system'
    },
    'userRoles': {
      'acoustical_engineer': 'Acoustical Engineer',
      'architect': 'Architect',
      'architectural_technician': 'Architectural Technician',
      'architectural_technologist': 'Architectural Technologist',
      'assistant_project_manager': 'Assistant Project Manager',
      'assistant_superintendent': 'Assistant Superintendent',
      'bim_coordinator': 'BIM Coordinator',
      'bim_engineer': 'BIM Engineer',
      'bim_manager': 'BIM Manager',
      'bim_technician': 'BIM Technician',
      'building_inspector': 'Building Inspector',
      'building_services_engineer': 'Building Services Engineer',
      'building_supervisor': 'Building Supervisor',
      'building_surveyor': 'Building Surveyor',
      'business_development_manager': 'Business Development Manager',
      'buyer': 'Buyer',
      'cad_operator': 'CAD Operator',
      'civil_engineer': 'Civil Engineer',
      'commercial_manager': 'Commercial Manager',
      'commissioning_manager': 'Commissioning Manager',
      'construction_coordinator': 'Construction Coordinator',
      'construction_manager': 'Construction Manager',
      'construction_technician': 'Construction Technician',
      'consultant': 'Consultant',
      'contract_administrator': 'Contract Administrator',
      'contract_manager': 'Contract Manager',
      'contractor': 'Contractor',
      'coordinator': 'Coordinator',
      'cost_engineer': 'Cost Engineer',
      'cost_manager': 'Cost Manager',
      'defects_manager': 'Defects Manager',
      'design_manager': 'Design Manager',
      'designer': 'Designer',
      'director': 'Director',
      'director_of_design': 'Director of Design',
      'director_of_operations': 'Director of Operations',
      'document_controller': 'Document Controller',
      'document_manager': 'Document Manager',
      'drafter': 'Drafter',
      'electrical_engineer': 'Electrical Engineer',
      'employers_agent': 'Employers Agent',
      'engineer': 'Engineer',
      'environmental_engineer': 'Environmental Engineer',
      'estimator': 'Estimator',
      'executive': 'Executive',
      'facilities_director': 'Facilities Director',
      'facilities_manager': 'Facilities Manager',
      'field_controller': 'Field Controller',
      'field_engineer': 'Field Engineer',
      'field_supervisor': 'Field Supervisor',
      'field_viewer': 'Field Viewer (for BIM Station / JOBOX)',
      'fire_safety_engineer': 'Fire Safety Engineer',
      'foreman': 'Foreman',
      'hvac_engineer': 'HVAC Engineer',
      'inspector': 'Inspector',
      'interior_architect': 'Interior Architect',
      'interior_designer': 'Interior Designer',
      'it': 'IT',
      'lighting_designer': 'Lighting Designer',
      'managing_director': 'Managing Director',
      'mechanical_engineer': 'Mechanical Engineer',
      'mep_engineer': 'MEP Engineer',
      'owner': 'Owner',
      'owner_representative': 'Owner Representative',
      'planner': 'Planner',
      'plumbing_engineer': 'Plumbing Engineer',
      'principal_architect': 'Principal Architect',
      'process_engineer': 'Process Engineer',
      'procurement': 'Procurement',
      'procurement_specialist': 'Procurement Specialist',
      'project_controls_engineer': 'Project Controls Engineer',
      'project_director': 'Project Director',
      'project_engineer': 'Project Engineer',
      'project_leader': 'Project Leader',
      'project_manager': 'Project Manager',
      'purchasing_coordinator': 'Purchasing Coordinator',
      'quality_manager': 'Quality Manager',
      'quantity_surveyor': 'Quantity Surveyor',
      'real_estate_manager': 'Real Estate Manager',
      'risk_engineer': 'Risk Engineer',
      'risk_manager': 'Risk Manager',
      'safety_manager': 'Safety Manager',
      'scheduler': 'Scheduler',
      'self_perform_foreman': 'Self Perform Foreman',
      'services_engineer': 'Services Engineer',
      'site_engineer': 'Site Engineer',
      'site_manager': 'Site Manager',
      'site_supervisor': 'Site Supervisor',
      'structural_engineer': 'Structural Engineer',
      'subcontractor': 'Subcontractor',
      'superintendent': 'Superintendent',
      'surveyor': 'Surveyor',
      'team_leader': 'Team Leader',
      'transportation_engineer': 'Transportation Engineer',
      'vdc_engineer': 'VDC Engineer',
      'vdc_manager': 'VDC Manager',
      'vp_quality': 'VP Quality',
      'vp_safety': 'VP Safety'
    }
  },
  'cs': {
    'topFolder': {
      'projectFiles': 'Soubory projektu',
      'forTheField': 'Pro pole'
    },
    'permissions': {
      'everyone': 'Všichni'
    },
    'attributes': {
      'title': 'Název',
      'number': 'Číslo',
      'sheetNumber': 'Číslo listu',
      'project': 'Projekt',
      'originator': 'Původce',
      'volumeSystem': 'Objem/systém',
      'levelLocation': 'Úroveň/umístění',
      'type': 'Typ',
      'role': 'Role',
      'status': 'Stav',
      'revision': 'Revize',
      'classification': 'Klasifikace'
    },
    'users': {
      'accSystem': 'systém ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Akustický technik',
      'architect': 'Architekt',
      'architectural_technician': 'Architekt – technik',
      'architectural_technologist': 'Architekt – technolog',
      'assistant_project_manager': 'Pomocný manažer projektu',
      'assistant_superintendent': 'Pomocný dozorce',
      'bim_coordinator': 'Koordinátor BIM',
      'bim_engineer': 'Inženýr BIM',
      'bim_manager': 'Správce BIM',
      'bim_technician': 'Technik BIM',
      'building_inspector': 'Inspektor budov',
      'building_services_engineer': 'Stavební inženýr',
      'building_supervisor': 'Vedoucí budovy',
      'building_surveyor': 'Stavební zeměměřič',
      'business_development_manager': 'Manažer obchodního rozvoje',
      'buyer': 'Nákupčí',
      'cad_operator': 'Operátor CAD',
      'civil_engineer': 'Stavební inženýr',
      'commercial_manager': 'Obchodní manažer',
      'commissioning_manager': 'Manažer uvedení do provozu',
      'construction_coordinator': 'Koordinátor stavby',
      'construction_manager': 'Stavbyvedoucí',
      'construction_technician': 'Stavební technik',
      'consultant': 'Konsultant',
      'contract_administrator': 'Správce smlouvy',
      'contract_manager': 'Správce smlouvy',
      'contractor': 'Dodavatel',
      'coordinator': 'Koordinátor',
      'cost_engineer': 'Finanční inženýr',
      'cost_manager': 'Správce nákladů',
      'defects_manager': 'Manažer defektů',
      'design_manager': 'Manažer návrhu',
      'designer': 'Návrhář',
      'director': 'Ředitel',
      'director_of_design': 'ředitel projektu',
      'director_of_operations': 'Ředitel provozu',
      'document_controller': 'Správce dokumentů',
      'document_manager': 'Správce dokumentů',
      'drafter': 'Kreslič',
      'electrical_engineer': 'Elektrotechnik',
      'employers_agent': 'Pracovník zaměstnavatelů',
      'engineer': 'Technik',
      'environmental_engineer': 'Environmentální inženýr',
      'estimator': 'Odhadce',
      'executive': 'Manažer',
      'facilities_director': 'Ředitel zařízení',
      'facilities_manager': 'Manažer zařízení',
      'field_controller': 'Kontrolor v terénu',
      'field_engineer': 'Inženýr v terénu',
      'field_supervisor': 'Dohlížitel v terénu',
      'field_viewer': 'Pozorovatel v terénu (pro BIM Station / JOBOX)',
      'fire_safety_engineer': 'Požární Bezpečnostní Inženýr',
      'foreman': 'Předák',
      'hvac_engineer': 'Inženýr TZB',
      'inspector': 'Inspektor',
      'interior_architect': 'Architekt interiérů',
      'interior_designer': 'Interiérový designér',
      'it': 'IT',
      'lighting_designer': 'Světelný technik',
      'managing_director': 'Vedoucí ředitel',
      'mechanical_engineer': 'Inženýr strojírenství',
      'mep_engineer': 'Inženýr TZB',
      'owner': 'Vlastník',
      'owner_representative': 'Zástupce vlastníka',
      'planner': 'Plánovač',
      'plumbing_engineer': 'Instalační technik',
      'principal_architect': 'Hlavní architekt',
      'process_engineer': 'Provozní technik',
      'procurement': 'Zásobování',
      'procurement_specialist': 'Specialista na nákup',
      'project_controls_engineer': 'Projektový manažer řízení',
      'project_director': 'Projektový ředitel',
      'project_engineer': 'Projektový technik',
      'project_leader': 'Vedoucí projektu',
      'project_manager': 'Správce projektu',
      'purchasing_coordinator': 'Nákupní koordinátor',
      'quality_manager': 'Správce kvality',
      'quantity_surveyor': 'Stavební ekonom',
      'real_estate_manager': 'správce nemovitostí',
      'risk_engineer': 'Rizikový technik',
      'risk_manager': 'Manažer rizik',
      'safety_manager': 'Správce bezpečnosti',
      'scheduler': 'Plánovač',
      'self_perform_foreman': 'Samostatný předák',
      'services_engineer': 'Inženýr služeb',
      'site_engineer': 'Inženýr staveniště',
      'site_manager': 'Manažer pracoviště',
      'site_supervisor': 'Dohlížitel na pracovišti',
      'structural_engineer': 'Konstrukční inženýr',
      'subcontractor': 'Subdodavatel',
      'superintendent': 'Dozorce',
      'surveyor': 'Zeměměřič',
      'team_leader': 'Týmový vedoucí',
      'transportation_engineer': 'Dopravní inženýr',
      'vdc_engineer': 'Inženýr VDC',
      'vdc_manager': 'Správce VDC',
      'vp_quality': 'Kvalita VP',
      'vp_safety': 'Bezpečnost VP'
    }
  },
  'da': {
    'topFolder': {
      'projectFiles': 'Projektfiler',
      'forTheField': 'Til felten'
    },
    'permissions': {
      'everyone': 'Alle'
    },
    'attributes': {
      'title': 'Titel',
      'number': 'Nummer',
      'sheetNumber': 'Arknummer',
      'project': 'Projekt',
      'originator': 'Skaber',
      'volumeSystem': 'Volumen/system',
      'levelLocation': 'Niveau/placering',
      'type': 'Type',
      'role': 'Rolle',
      'status': 'Status',
      'revision': 'Gennemgang',
      'classification': 'Klassificering'
    },
    'users': {
      'accSystem': 'ACC-system'
    },
    'userRoles': {
      'acoustical_engineer': 'Akustiktekniker',
      'architect': 'Arkitekt',
      'architectural_technician': 'Bygningstekniker',
      'architectural_technologist': 'Bygningsteknikumingeniør',
      'assistant_project_manager': 'Assisterende projektleder',
      'assistant_superintendent': 'Assisterende driftsleder',
      'bim_coordinator': 'BIM-koordinator',
      'bim_engineer': 'BIM-tekniker',
      'bim_manager': 'BIM-leder',
      'bim_technician': 'BIM-tekniker',
      'building_inspector': 'Bygningsinspektør',
      'building_services_engineer': 'Bygningsservicetekniker',
      'building_supervisor': 'Bygningstilsynsførende',
      'building_surveyor': 'Syns- og skønsmand for bygning',
      'business_development_manager': 'Forretningsudviklingschef',
      'buyer': 'Køber',
      'cad_operator': 'CAD-operatør',
      'civil_engineer': 'Civilingeniør',
      'commercial_manager': 'Erhvervsleder',
      'commissioning_manager': 'Kommissioningschef',
      'construction_coordinator': 'Konstruktionskoordinator',
      'construction_manager': 'Byggeleder',
      'construction_technician': 'Konstruktionstekniker',
      'consultant': 'Konsulent',
      'contract_administrator': 'Kontraktadministrator',
      'contract_manager': 'Kontraktleder',
      'contractor': 'Entreprenør',
      'coordinator': 'Koordinator',
      'cost_engineer': 'Omkostningsorganisator',
      'cost_manager': 'Omkostningsansvarlig',
      'defects_manager': 'Defektansvarlig',
      'design_manager': 'Designchef',
      'designer': 'Designer',
      'director': 'Direktør',
      'director_of_design': 'Direktør for design',
      'director_of_operations': 'Driftsdirektør',
      'document_controller': 'Dokumentcontroller',
      'document_manager': 'Dokumentleder',
      'drafter': 'Teknisk tegner',
      'electrical_engineer': 'Elektroingeniør',
      'employers_agent': 'Arbejdsgiveragent',
      'engineer': 'Ingeniør',
      'environmental_engineer': 'Miljøingeniør',
      'estimator': 'Estimator',
      'executive': 'Leder',
      'facilities_director': 'Facilitetsdirektør',
      'facilities_manager': 'Facilitetsleder',
      'field_controller': 'Feltansvarlig',
      'field_engineer': 'Felttekniker',
      'field_supervisor': 'Feltinspektør',
      'field_viewer': 'Feltfremviser (til BIM Station/JOBOX)',
      'fire_safety_engineer': 'Brandingeniør',
      'foreman': 'Formand',
      'hvac_engineer': 'HVAC-ingeniør',
      'inspector': 'Tilsynsførende',
      'interior_architect': 'Indretningsarkitekt',
      'interior_designer': 'Indretningsdesigner',
      'it': 'It',
      'lighting_designer': 'Lysdesigner',
      'managing_director': 'Administrerende direktør',
      'mechanical_engineer': 'Maskiningeniør',
      'mep_engineer': 'MEP-tekniker',
      'owner': 'Ejer',
      'owner_representative': 'Ejerrepræsentant',
      'planner': 'Planlægger',
      'plumbing_engineer': 'VVS-ingeniør',
      'principal_architect': 'Hovedarkitekt',
      'process_engineer': 'Procestekniker',
      'procurement': 'Indkøb',
      'procurement_specialist': 'Indkøbsspecialist',
      'project_controls_engineer': 'Projektkontroltekniker',
      'project_director': 'Projektdirektør',
      'project_engineer': 'Projektingeniør',
      'project_leader': 'Projektchef',
      'project_manager': 'Projektleder',
      'purchasing_coordinator': 'Indkøbskoordinator',
      'quality_manager': 'Kvalitetsleder',
      'quantity_surveyor': 'Rådgivende ingeniør',
      'real_estate_manager': 'Leder af fast ejendom',
      'risk_engineer': 'Risikotekniker',
      'risk_manager': 'Risikoleder',
      'safety_manager': 'Sikkerhedsansvarlig',
      'scheduler': 'Planlægger',
      'self_perform_foreman': 'Selvstændig formand',
      'services_engineer': 'Servicetekniker',
      'site_engineer': 'Byggeingeniør',
      'site_manager': 'Byggeleder',
      'site_supervisor': 'Byggeinspektør',
      'structural_engineer': 'Konstruktionsingeniør',
      'subcontractor': 'Underleverandør',
      'superintendent': 'Driftschef',
      'surveyor': 'Synsmand',
      'team_leader': 'Teamleder',
      'transportation_engineer': 'Transportingeniør',
      'vdc_engineer': 'VDC-tekniker',
      'vdc_manager': 'VDC-leder',
      'vp_quality': 'Vicedirektør, kvalitet',
      'vp_safety': 'Vicedirektør, sikkerhed'
    }
  },
  'de': {
    'topFolder': {
      'projectFiles': 'Projektdateien',
      'forTheField': 'Für die Baustelle'
    },
    'permissions': {
      'everyone': 'Alle'
    },
    'attributes': {
      'title': 'Titel',
      'number': 'Nummer',
      'sheetNumber': 'Plannummer',
      'project': 'Projekt',
      'originator': 'Urheber',
      'volumeSystem': 'Volumen/System',
      'levelLocation': 'Ebene/Standort',
      'type': 'Typ',
      'role': 'Rolle',
      'status': 'Status',
      'revision': 'Revision',
      'classification': 'Klassifizierung'
    },
    'users': {
      'accSystem': 'ACC-System'
    },
    'userRoles': {
      'acoustical_engineer': 'Akustik-Ingenieur',
      'architect': 'Architekt',
      'architectural_technician': 'Architektur-Techniker',
      'architectural_technologist': 'Architektur-Technologiespezialist',
      'assistant_project_manager': 'Assistent der Projektleitung',
      'assistant_superintendent': 'Assistent der Bauleitung',
      'bim_coordinator': 'BIM-Koordinator',
      'bim_engineer': 'BIM-Ingenieur',
      'bim_manager': 'BIM-Manager',
      'bim_technician': 'BIM-Techniker',
      'building_inspector': 'Gebäudeinspektor',
      'building_services_engineer': 'Gebäudetechniker',
      'building_supervisor': 'Bauaufseher',
      'building_surveyor': 'Vermessungsingenieur',
      'business_development_manager': 'Manager der Geschäftsentwicklung',
      'buyer': 'Käufer',
      'cad_operator': 'CAD-Operator',
      'civil_engineer': 'Tiefbauingenieur',
      'commercial_manager': 'Kaufmännischer Manager',
      'commissioning_manager': 'Inbetriebnahme-Manager',
      'construction_coordinator': 'Baukoordinator',
      'construction_manager': 'Bauleiter',
      'construction_technician': 'Bautechniker',
      'consultant': 'Berater',
      'contract_administrator': 'Vertragsadministrator',
      'contract_manager': 'Vertragsmanager',
      'contractor': 'Auftragnehmer',
      'coordinator': 'Koordinator',
      'cost_engineer': 'Kosteningenieur',
      'cost_manager': 'Kostenmanager',
      'defects_manager': 'Fehlermanager',
      'design_manager': 'Planungsleiter',
      'designer': 'Designer',
      'director': 'Leiter',
      'director_of_design': 'Designverantwortlicher',
      'director_of_operations': 'Betriebsleiter',
      'document_controller': 'Dokument-Controller',
      'document_manager': 'Dokumentverwalter',
      'drafter': 'Bauzeichner',
      'electrical_engineer': 'Elektrotechniker',
      'employers_agent': 'Arbeitgeber-Agent',
      'engineer': 'Ingenieur',
      'environmental_engineer': 'Umweltingenieur',
      'estimator': 'Kostenplaner',
      'executive': 'Führungskraft',
      'facilities_director': 'Anlagenleiter',
      'facilities_manager': 'Gebäudeverwalter',
      'field_controller': 'Baustellen-Controller',
      'field_engineer': 'Außendiensttechniker',
      'field_supervisor': 'Baustellenleiter',
      'field_viewer': 'Field-Viewer (für BIM Station/JOBOX)',
      'fire_safety_engineer': 'Brandschutzanalyse-Ingenieur',
      'foreman': 'Vorarbeiter',
      'hvac_engineer': 'HLK-Techniker',
      'inspector': 'Inspektor',
      'interior_architect': 'Innenarchitekt',
      'interior_designer': 'Innenausstatter',
      'it': 'IT',
      'lighting_designer': 'Beleuchtungsdesigner',
      'managing_director': 'Geschäftsführer',
      'mechanical_engineer': 'Maschinenbauingenieur',
      'mep_engineer': 'Gebäudetechnikingenieur',
      'owner': 'Auftraggeber',
      'owner_representative': 'Vertreter des Auftraggebers',
      'planner': 'Planer',
      'plumbing_engineer': 'Installationsingenieur',
      'principal_architect': 'Leitender Architekt',
      'process_engineer': 'Verfahrenstechniker',
      'procurement': 'Beschaffung',
      'procurement_specialist': 'Beschaffungsspezialist',
      'project_controls_engineer': 'Ingenieur Projektcontrolling',
      'project_director': 'Projektleiter',
      'project_engineer': 'Projektingenieur',
      'project_leader': 'Projektleiter',
      'project_manager': 'Projektmanager',
      'purchasing_coordinator': 'Koordinator im Einkauf',
      'quality_manager': 'Qualitätsmanager',
      'quantity_surveyor': 'Mengenermittler',
      'real_estate_manager': 'Immobilien-Manager',
      'risk_engineer': 'Risiko-Ingenieur',
      'risk_manager': 'Risiko-Manager',
      'safety_manager': 'Sicherheitsmanager',
      'scheduler': 'Aufgabenplaner',
      'self_perform_foreman': 'Mitarbeitender Vorarbeiter',
      'services_engineer': 'Gebäudetechniker',
      'site_engineer': 'Bautechniker',
      'site_manager': 'Baustellenmanager',
      'site_supervisor': 'Baustellenverantwortlicher',
      'structural_engineer': 'Statiker',
      'subcontractor': 'Nachunternehmer',
      'superintendent': 'Aufseher',
      'surveyor': 'Landvermesser',
      'team_leader': 'Teamleiter',
      'transportation_engineer': 'Transportingenieur',
      'vdc_engineer': 'VDC-Ingenieur',
      'vdc_manager': 'VDC-Manager',
      'vp_quality': 'Bereichsleiter Qualität',
      'vp_safety': 'Bereichsleiter Sicherheit'
    }
  },
  'en-GB': {
    'topFolder': {
      'projectFiles': 'Project Files',
      'forTheField': 'For the Field'
    },
    'permissions': {
      'everyone': 'Everyone'
    },
    'attributes': {
      'title': 'Title',
      'number': 'Number',
      'sheetNumber': 'Sheet number',
      'project': 'Project',
      'originator': 'Originator',
      'volumeSystem': 'Volume/System',
      'levelLocation': 'Level/Location',
      'type': 'Type',
      'role': 'Role',
      'status': 'Status',
      'revision': 'Revision',
      'classification': 'Classification'
    },
    'users': {
      'accSystem': 'ACC system'
    },
    'userRoles': {
      'acoustical_engineer': 'Acoustical Engineer',
      'architect': 'Architect',
      'architectural_technician': 'Architectural Technician',
      'architectural_technologist': 'Architectural Technologist',
      'assistant_project_manager': 'Assistant Project Manager',
      'assistant_superintendent': 'Assistant Superintendent',
      'bim_coordinator': 'BIM Coordinator',
      'bim_engineer': 'BIM Engineer',
      'bim_manager': 'BIM Manager',
      'bim_technician': 'BIM Technician',
      'building_inspector': 'Building Inspector',
      'building_services_engineer': 'Building Services Engineer',
      'building_supervisor': 'Building Supervisor',
      'building_surveyor': 'Building Surveyor',
      'business_development_manager': 'Business Development Manager',
      'buyer': 'Buyer',
      'cad_operator': 'CAD Operator',
      'civil_engineer': 'Civil Engineer',
      'commercial_manager': 'Commercial Manager',
      'commissioning_manager': 'Commissioning Manager',
      'construction_coordinator': 'Construction Coordinator',
      'construction_manager': 'Construction Manager',
      'construction_technician': 'Construction Technician',
      'consultant': 'Consultant',
      'contract_administrator': 'Contract Administrator',
      'contract_manager': 'Contract Manager',
      'contractor': 'Contractor',
      'coordinator': 'Coordinator',
      'cost_engineer': 'Cost Engineer',
      'cost_manager': 'Cost Manager',
      'defects_manager': 'Defects Manager',
      'design_manager': 'Design Manager',
      'designer': 'Designer',
      'director': 'Director',
      'director_of_design': 'Director of Design',
      'director_of_operations': 'Director of Operations',
      'document_controller': 'Document Controller',
      'document_manager': 'Document Manager',
      'drafter': 'Drafter',
      'electrical_engineer': 'Electrical Engineer',
      'employers_agent': 'Employers Agent',
      'engineer': 'Engineer',
      'environmental_engineer': 'Environmental Engineer',
      'estimator': 'Estimator',
      'executive': 'Executive',
      'facilities_director': 'Facilities Director',
      'facilities_manager': 'Facilities Manager',
      'field_controller': 'Field Controller',
      'field_engineer': 'Field Engineer',
      'field_supervisor': 'Field Supervisor',
      'field_viewer': 'Field Viewer (for BIM Station/JOBOX)',
      'fire_safety_engineer': 'Fire Safety Engineer',
      'foreman': 'Foreman',
      'hvac_engineer': 'HVAC Engineer',
      'inspector': 'Inspector',
      'interior_architect': 'Interior Architect',
      'interior_designer': 'Interior Designer',
      'it': 'IT',
      'lighting_designer': 'Lighting Designer',
      'managing_director': 'Managing Director',
      'mechanical_engineer': 'Mechanical Engineer',
      'mep_engineer': 'MEP Engineer',
      'owner': 'Owner',
      'owner_representative': 'Owner Representative',
      'planner': 'Planner',
      'plumbing_engineer': 'Plumbing Engineer',
      'principal_architect': 'Principal Architect',
      'process_engineer': 'Process Engineer',
      'procurement': 'Procurement',
      'procurement_specialist': 'Procurement Specialist',
      'project_controls_engineer': 'Project Controls Engineer',
      'project_director': 'Project Director',
      'project_engineer': 'Project Engineer',
      'project_leader': 'Project Leader',
      'project_manager': 'Project Manager',
      'purchasing_coordinator': 'Purchasing Coordinator',
      'quality_manager': 'Quality Manager',
      'quantity_surveyor': 'Quantity Surveyor',
      'real_estate_manager': 'Real Estate Manager',
      'risk_engineer': 'Risk Engineer',
      'risk_manager': 'Risk Manager',
      'safety_manager': 'Safety Manager',
      'scheduler': 'Scheduler',
      'self_perform_foreman': 'Self-Perform Foreman',
      'services_engineer': 'Services Engineer',
      'site_engineer': 'Site Engineer',
      'site_manager': 'Site Manager',
      'site_supervisor': 'Site Supervisor',
      'structural_engineer': 'Structural Engineer',
      'subcontractor': 'Subcontractor',
      'superintendent': 'Superintendent',
      'surveyor': 'Surveyor',
      'team_leader': 'Team Leader',
      'transportation_engineer': 'Transport Engineer',
      'vdc_engineer': 'VDC Engineer',
      'vdc_manager': 'VDC Manager',
      'vp_quality': 'VP Quality',
      'vp_safety': 'VP Safety'
    }
  },
  'es': {
    'topFolder': {
      'projectFiles': 'Archivos de proyecto',
      'forTheField': 'Para el campo'
    },
    'permissions': {
      'everyone': 'Todos'
    },
    'attributes': {
      'title': 'Título',
      'number': 'Número',
      'sheetNumber': 'Número de hoja',
      'project': 'Proyecto',
      'originator': 'Creador',
      'volumeSystem': 'Volumen/Sistema',
      'levelLocation': 'Nivel/Ubicación',
      'type': 'Tipo',
      'role': 'Función',
      'status': 'Estado',
      'revision': 'Revisión',
      'classification': 'Clasificación'
    },
    'users': {
      'accSystem': 'Sistema ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Ingeniero acústico',
      'architect': 'Arquitecto',
      'architectural_technician': 'Técnico arquitectónico',
      'architectural_technologist': 'Tecnólogo arquitectónico',
      'assistant_project_manager': 'Administrador de proyectos auxiliar',
      'assistant_superintendent': 'Superintendente auxiliar',
      'bim_coordinator': 'Coordinador de BIM',
      'bim_engineer': 'Ingeniero de BIM',
      'bim_manager': 'Administrador de BIM',
      'bim_technician': 'Técnico de BIM',
      'building_inspector': 'Inspector de construcción',
      'building_services_engineer': 'Ingeniero de servicios de construcción',
      'building_supervisor': 'Supervisor de construcción',
      'building_surveyor': 'Topógrafo de construcción',
      'business_development_manager': 'Administrador de desarrollo de negocios',
      'buyer': 'Comprador',
      'cad_operator': 'Operador de CAD',
      'civil_engineer': 'Ingeniero civil',
      'commercial_manager': 'Administrador comercial',
      'commissioning_manager': 'Administrador de puesta en marcha',
      'construction_coordinator': 'Coordinador de construcción',
      'construction_manager': 'Jefe de obra',
      'construction_technician': 'Técnico de construcción',
      'consultant': 'Asesor',
      'contract_administrator': 'Administrador de contratos',
      'contract_manager': 'Administrador de contratos',
      'contractor': 'Contratista',
      'coordinator': 'Coordinador',
      'cost_engineer': 'Ingeniero de costes',
      'cost_manager': 'Administrador de costes',
      'defects_manager': 'Administrador de defectos',
      'design_manager': 'Administrador de diseño',
      'designer': 'Diseñador',
      'director': 'Director',
      'director_of_design': 'Director de diseño',
      'director_of_operations': 'Director de operaciones',
      'document_controller': 'Controlador de documentos',
      'document_manager': 'Administrador de documentos',
      'drafter': 'Delineante',
      'electrical_engineer': 'Ingeniero eléctrico',
      'employers_agent': 'Agente de las empresas',
      'engineer': 'Ingeniero',
      'environmental_engineer': 'Ingeniero medioambiental',
      'estimator': 'Responsable de estimación',
      'executive': 'Ejecutivo',
      'facilities_director': 'Director de instalaciones',
      'facilities_manager': 'Jefe de instalaciones',
      'field_controller': 'Controlador de campo',
      'field_engineer': 'Ingeniero de obra',
      'field_supervisor': 'Supervisor de obra',
      'field_viewer': 'Inspector de obra (para estación BIM/JOBOX)',
      'fire_safety_engineer': 'Ingeniero de protección contra incendios',
      'foreman': 'Capataz',
      'hvac_engineer': 'Ingeniero de climatización',
      'inspector': 'Inspector',
      'interior_architect': 'Arquitecto de interiores',
      'interior_designer': 'Diseñador de interiores',
      'it': 'TI',
      'lighting_designer': 'Diseñador de iluminación',
      'managing_director': 'Director de administración',
      'mechanical_engineer': 'Ingeniero mecánico',
      'mep_engineer': 'Ingeniero de MEP',
      'owner': 'Propietario',
      'owner_representative': 'Representante del propietario',
      'planner': 'Planificador',
      'plumbing_engineer': 'Ingeniero de fontanería',
      'principal_architect': 'Arquitecto principal',
      'process_engineer': 'Ingeniero de procesos',
      'procurement': 'Encargado de adquisiciones',
      'procurement_specialist': 'Especialista de adquisiciones',
      'project_controls_engineer': 'Ingeniero de controles de proyecto',
      'project_director': 'Director de proyecto',
      'project_engineer': 'Ingeniero de proyectos',
      'project_leader': 'Jefe de proyecto',
      'project_manager': 'Gestor de proyectos',
      'purchasing_coordinator': 'Coordinador de compra',
      'quality_manager': 'Administrador de calidad',
      'quantity_surveyor': 'Inspector de obra',
      'real_estate_manager': 'Director de bienes raíces',
      'risk_engineer': 'Ingeniero de riesgos',
      'risk_manager': 'Administrador de riesgos',
      'safety_manager': 'Administrador de seguridad',
      'scheduler': 'Programador',
      'self_perform_foreman': 'Capataz de rendimiento',
      'services_engineer': 'Ingeniero de servicios',
      'site_engineer': 'Ingeniero del emplazamiento',
      'site_manager': 'Administrador del emplazamiento',
      'site_supervisor': 'Supervisor del emplazamiento',
      'structural_engineer': 'Ingeniero de estructuras',
      'subcontractor': 'Subcontratista',
      'superintendent': 'Superintendente',
      'surveyor': 'Topógrafo',
      'team_leader': 'Jefe de equipo',
      'transportation_engineer': 'Ingeniero de transporte',
      'vdc_engineer': 'Ingeniero de VDC',
      'vdc_manager': 'Administrador de VDC',
      'vp_quality': 'VP de calidad',
      'vp_safety': 'VP de seguridad'
    }
  },
  'fr-CA': {
    'topFolder': {
      'projectFiles': 'Fichiers de projet',
      'forTheField': 'Pour le chantier'
    },
    'permissions': {
      'everyone': 'Tous'
    },
    'attributes': {
      'title': 'Titre',
      'number': 'Numéro',
      'sheetNumber': 'Numéro de la feuille',
      'project': 'Projet',
      'originator': 'Originateur',
      'volumeSystem': 'Volume/Système',
      'levelLocation': 'Niveau/Emplacement',
      'type': 'Type',
      'role': 'Rôle',
      'status': 'État',
      'revision': 'Révision',
      'classification': 'Classification'
    },
    'users': {
      'accSystem': 'Système ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Ingénieur acoustique',
      'architect': 'Architecte',
      'architectural_technician': 'Technicien en architecture',
      'architectural_technologist': 'Technologue en architecture',
      'assistant_project_manager': 'Assistant du gestionnaire de projets',
      'assistant_superintendent': 'Assistant de chantier',
      'bim_coordinator': 'Coordinateur BIM',
      'bim_engineer': 'Ingénieur BIM',
      'bim_manager': 'Responsable BIM',
      'bim_technician': 'Technicien BIM',
      'building_inspector': 'Inspecteur de bâtiment',
      'building_services_engineer': 'Ingénieur en services du bâtiment',
      'building_supervisor': 'Superviseur de bâtiment',
      'building_surveyor': 'Géomètre en bâtiment',
      'business_development_manager': 'Responsable du développement commercial',
      'buyer': 'Acheteur',
      'cad_operator': 'Opérateur CAO',
      'civil_engineer': 'Ingénieur civil',
      'commercial_manager': 'Gestionnaire commercial',
      'commissioning_manager': 'Gestionnaire de mise en service',
      'construction_coordinator': 'Coordinateur de la construction',
      'construction_manager': 'Directeur de travaux de construction',
      'construction_technician': 'Technicien de construction',
      'consultant': 'Consultant',
      'contract_administrator': 'Administrateur de contrats',
      'contract_manager': 'Gestionnaire de contrat',
      'contractor': 'Fournisseur',
      'coordinator': 'Coordinateur',
      'cost_engineer': 'Ingénieur spécialiste des coûts',
      'cost_manager': 'Gestionnaire de coûts',
      'defects_manager': 'Gestionnaire des défectuosités',
      'design_manager': 'Responsable de la conception',
      'designer': 'Concepteur',
      'director': 'Directeur',
      'director_of_design': 'Directeur de la conception',
      'director_of_operations': 'Directeur des opérations',
      'document_controller': 'Contrôleur de document',
      'document_manager': 'Gestionnaire de documents',
      'drafter': 'Dessinateur',
      'electrical_engineer': 'Ingénieur électricien',
      'employers_agent': "Représentant de l'employeur",
      'engineer': 'Ingénieur',
      'environmental_engineer': "Ingénieur spécialiste de l'environnement",
      'estimator': 'Évaluateur des coûts',
      'executive': 'Cadre de direction',
      'facilities_director': 'Directeur des installations',
      'facilities_manager': 'Responsable des installations',
      'field_controller': 'Contrôleur de chantier',
      'field_engineer': 'Ingénieur de chantier',
      'field_supervisor': 'Superviseur de chantier',
      'field_viewer': 'Visualiseur (pour BIM Station / JOBOX)',
      'fire_safety_engineer': 'Ingénieur de sécurité incendie',
      'foreman': 'Contremaître',
      'hvac_engineer': 'Ingénieur CVC',
      'inspector': 'Inspecteur',
      'interior_architect': "Architecte d'intérieur",
      'interior_designer': "Designer d'intérieur",
      'it': 'TI',
      'lighting_designer': 'Concepteur en éclairage',
      'managing_director': 'Directeur général',
      'mechanical_engineer': 'Ingénieur mécanique',
      'mep_engineer': 'Ingénieur MEP',
      'owner': 'Propriétaire',
      'owner_representative': 'Représentant du propriétaire',
      'planner': 'Planificateur',
      'plumbing_engineer': 'Ingénieur en plomberie',
      'principal_architect': 'Architecte en chef',
      'process_engineer': 'Ingénieur des procédés',
      'procurement': 'Achats',
      'procurement_specialist': 'Spécialiste en approvisionnement',
      'project_controls_engineer': 'Ingénieur en contrôles de projet',
      'project_director': 'Directeur de projet',
      'project_engineer': 'Ingénieur du projet',
      'project_leader': 'Chef de projet',
      'project_manager': 'Gestionnaire de projet',
      'purchasing_coordinator': 'Coordinateur des achats',
      'quality_manager': 'Responsable qualité',
      'quantity_surveyor': 'Contrôleur des coûts',
      'real_estate_manager': 'Gestionnaire immobilier',
      'risk_engineer': 'Ingénieur des risques',
      'risk_manager': 'Gestionnaire des risques',
      'safety_manager': 'Gestionnaire de la sécurité',
      'scheduler': "Responsable de l'ordonnancement",
      'self_perform_foreman': 'Contremaître autonome',
      'services_engineer': 'Ingénieur en services',
      'site_engineer': 'Ingénieur de site',
      'site_manager': 'Gestionnaire de site',
      'site_supervisor': 'Superviseur de site',
      'structural_engineer': 'Ingénieur structure',
      'subcontractor': 'Sous-traitant',
      'superintendent': 'Chef de chantier',
      'surveyor': 'Géomètre',
      'team_leader': "Responsable de l'équipe",
      'transportation_engineer': 'Ingénieur en transports',
      'vdc_engineer': 'Ingénieur VDC',
      'vdc_manager': 'Responsable VDC',
      'vp_quality': 'Vice-président de la qualité',
      'vp_safety': 'Vice-président de la sécurité'
    }
  },
  'fr': {
    'topFolder': {
      'projectFiles': 'Fichiers de projet',
      'forTheField': 'Pour le chantier'
    },
    'permissions': {
      'everyone': 'Tous'
    },
    'attributes': {
      'title': 'Titre',
      'number': 'Numéro',
      'sheetNumber': 'Numéro de la feuille',
      'project': 'Projet',
      'originator': 'Initiateur',
      'volumeSystem': 'Volume/Système',
      'levelLocation': 'Niveau/Emplacement',
      'type': 'Type',
      'role': 'Rôle',
      'status': 'Statut',
      'revision': 'Révision',
      'classification': 'Classification'
    },
    'users': {
      'accSystem': 'Système ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Ingénieur acoustique',
      'architect': 'Architecte',
      'architectural_technician': 'Technicien en architecture',
      'architectural_technologist': 'Technologue en architecture',
      'assistant_project_manager': 'Assistant de gestion de projets',
      'assistant_superintendent': 'Chef de chantier assistant',
      'bim_coordinator': 'Coordinateur BIM',
      'bim_engineer': 'Ingénieur BIM',
      'bim_manager': 'Responsable BIM',
      'bim_technician': 'Technicien BIM',
      'building_inspector': 'Inspecteur en bâtiment',
      'building_services_engineer': 'Ingénieur en services de construction',
      'building_supervisor': 'Superviseur de la construction',
      'building_surveyor': 'Géomètre-expert',
      'business_development_manager': 'Responsable du développement commercial',
      'buyer': 'Acheteur',
      'cad_operator': 'Opérateur CAO',
      'civil_engineer': 'Ingénieur en génie civil',
      'commercial_manager': 'Responsable commercial',
      'commissioning_manager': 'Responsable de la mise en service',
      'construction_coordinator': 'Coordinateur de la construction',
      'construction_manager': 'Directeur de chantier',
      'construction_technician': 'Technicien de construction',
      'consultant': 'Consultant',
      'contract_administrator': 'Administrateur de contrats',
      'contract_manager': 'Gestionnaire de contrats',
      'contractor': 'Entrepreneur',
      'coordinator': 'Coordinateur',
      'cost_engineer': 'Chiffreur',
      'cost_manager': 'Gestionnaire financier',
      'defects_manager': 'Responsable du traitement des défauts',
      'design_manager': 'Responsable de la conception',
      'designer': 'Concepteur',
      'director': 'Directeur',
      'director_of_design': 'Directeur de la conception',
      'director_of_operations': 'Directeur des opérations',
      'document_controller': 'Contrôleur de documents',
      'document_manager': 'Gestionnaire de documents',
      'drafter': 'Dessinateur',
      'electrical_engineer': 'Ingénieur électricien',
      'employers_agent': 'Chargé de relations avec les employeurs',
      'engineer': 'Ingénieur',
      'environmental_engineer': "Ingénieur spécialiste de l'environnement",
      'estimator': 'Évaluateur',
      'executive': 'Cadre dirigeant',
      'facilities_director': 'Directeur des installations',
      'facilities_manager': 'Responsable des installations',
      'field_controller': 'Contrôleur de chantier',
      'field_engineer': 'Ingénieur de chantier',
      'field_supervisor': 'Superviseur de chantier',
      'field_viewer': 'Visualiseur de chantier (pour BIM Station/JOBOX)',
      'fire_safety_engineer': 'Ingénieur sécurité incendie',
      'foreman': 'Contremaître',
      'hvac_engineer': 'Ingénieur CVC',
      'inspector': 'Inspecteur',
      'interior_architect': "Architecte d'intérieur",
      'interior_designer': "Designer d'intérieur",
      'it': 'Informatique',
      'lighting_designer': 'Concepteur en éclairages',
      'managing_director': 'Directeur général',
      'mechanical_engineer': 'Ingénieur mécanique',
      'mep_engineer': 'Ingénieur MEP',
      'owner': "Maître d'ouvrage",
      'owner_representative': "Représentant du maître d'ouvrage",
      'planner': 'Urbaniste',
      'plumbing_engineer': 'Ingénieur hydraulicien',
      'principal_architect': 'Architecte en chef',
      'process_engineer': 'Ingénieur des procédés',
      'procurement': 'Achats',
      'procurement_specialist': 'Spécialiste des achats',
      'project_controls_engineer': 'Ingénieur en systèmes de commandes des projets',
      'project_director': 'Directeur de projet',
      'project_engineer': 'Conducteur de travaux',
      'project_leader': 'Chef de projet',
      'project_manager': 'Gestionnaire de projets',
      'purchasing_coordinator': 'Coordinateur des achats',
      'quality_manager': 'Responsable qualité',
      'quantity_surveyor': 'Métreur-vérificateur',
      'real_estate_manager': 'Responsable immobilier',
      'risk_engineer': 'Ingénieur des risques',
      'risk_manager': 'Gestionnaire des risques',
      'safety_manager': 'Gestionnaire de la sécurité',
      'scheduler': 'Planificateur',
      'self_perform_foreman': 'Contremaître autonome',
      'services_engineer': 'Ingénieur en services',
      'site_engineer': 'Ingénieur de chantier',
      'site_manager': 'Responsable de chantier',
      'site_supervisor': 'Superviseur de chantier',
      'structural_engineer': 'Ingénieur structure',
      'subcontractor': 'Sous-traitant',
      'superintendent': 'Chef de chantier',
      'surveyor': 'Géomètre',
      'team_leader': "Responsable d'équipe",
      'transportation_engineer': 'Ingénieur transports',
      'vdc_engineer': 'Ingénieur VDC',
      'vdc_manager': 'Responsable VDC',
      'vp_quality': 'Vice-président Qualité',
      'vp_safety': 'Vice-président Sécurité'
    }
  },
  'it': {
    'topFolder': {
      'projectFiles': 'File di progetto',
      'forTheField': 'Per il campo'
    },
    'permissions': {
      'everyone': 'Tutti'
    },
    'attributes': {
      'title': 'Titolo',
      'number': 'Numero',
      'sheetNumber': 'Numero foglio',
      'project': 'Progetto',
      'originator': 'Origine',
      'volumeSystem': 'Volume/Sistema',
      'levelLocation': 'Livello/Posizione',
      'type': 'Tipo',
      'role': 'Ruolo',
      'status': 'Stato',
      'revision': 'Riesame',
      'classification': 'Classificazione'
    },
    'users': {
      'accSystem': 'Sistema ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Ingegnere acustico',
      'architect': 'Architetto',
      'architectural_technician': 'Studio di architettura - Tecnico',
      'architectural_technologist': 'Studio di architettura - Responsabile tecnologico',
      'assistant_project_manager': 'Assistente project manager',
      'assistant_superintendent': 'Sovrintendente assistente',
      'bim_coordinator': 'Coordinatore BIM',
      'bim_engineer': 'Ingegnere BIM',
      'bim_manager': 'Responsabile BIM',
      'bim_technician': 'Tecnico BIM',
      'building_inspector': 'Ispettore edile',
      'building_services_engineer': 'Ingegnere dei servizi edili',
      'building_supervisor': 'Supervisore edile',
      'building_surveyor': 'Perito edile',
      'business_development_manager': 'Responsabile dello sviluppo aziendale',
      'buyer': 'Acquirente',
      'cad_operator': 'Operatore CAD',
      'civil_engineer': 'Ingegnere civile',
      'commercial_manager': 'Responsabile commerciale',
      'commissioning_manager': 'Responsabile della messa in funzione',
      'construction_coordinator': 'Coordinatore cantiere',
      'construction_manager': 'Responsabile della costruzione',
      'construction_technician': 'Tecnico cantiere',
      'consultant': 'Consulente',
      'contract_administrator': 'Amministratore del contratto',
      'contract_manager': 'Responsabile dei contratti',
      'contractor': 'Appaltatore',
      'coordinator': 'Coordinatore',
      'cost_engineer': 'Ingegnere dei costi',
      'cost_manager': 'Responsabile dei costi',
      'defects_manager': 'Responsabile della gestione dei difetti',
      'design_manager': 'Responsabile di progettazione',
      'designer': 'Progettista',
      'director': 'Direttore',
      'director_of_design': 'Direttore della progettazione',
      'director_of_operations': 'Direttore delle operazioni',
      'document_controller': 'Incaricato del controllo documenti',
      'document_manager': 'Responsabile della documentazione',
      'drafter': 'Disegnatore',
      'electrical_engineer': 'Ingegnere elettrico',
      'employers_agent': 'Rappresentante legale del cliente',
      'engineer': 'Ingegnere',
      'environmental_engineer': 'Ingegnere ambientale',
      'estimator': 'Perito',
      'executive': 'Dirigente',
      'facilities_director': 'Direttore impianti',
      'facilities_manager': 'Responsabile impianti',
      'field_controller': 'Incaricato del controllo sul campo',
      'field_engineer': 'Ingegnere sul campo',
      'field_supervisor': 'Supervisore sul campo',
      'field_viewer': 'Visualizzatore campi (per BIM Station/JOBOX)',
      'fire_safety_engineer': 'Ingegnere per la sicurezza antincendio',
      'foreman': 'Caposquadra',
      'hvac_engineer': 'Ingegnere HVAC',
      'inspector': 'Ispettore',
      'interior_architect': 'Architetto di interni',
      'interior_designer': 'Progettista di interni',
      'it': 'IT',
      'lighting_designer': 'Progettista illuminotecnico',
      'managing_director': 'Direttore amministrativo',
      'mechanical_engineer': 'Ingegnere meccanico',
      'mep_engineer': 'Ingegnere MEP',
      'owner': 'Proprietario',
      'owner_representative': 'Rappresentante proprietario',
      'planner': 'Responsabile pianificazione',
      'plumbing_engineer': 'Ingegnere idraulico',
      'principal_architect': 'Architetto capo',
      'process_engineer': 'Ingegnere di processo',
      'procurement': 'Approvvigionamento',
      'procurement_specialist': 'Specialista approvvigionamento',
      'project_controls_engineer': 'Ingegnere di controllo del progetto',
      'project_director': 'Direttore del progetto',
      'project_engineer': 'Ingegnere di progetto',
      'project_leader': 'Leader del progetto',
      'project_manager': 'Project manager',
      'purchasing_coordinator': 'Coordinatore acquisti',
      'quality_manager': 'Responsabile della qualità',
      'quantity_surveyor': 'Geometra',
      'real_estate_manager': 'Responsabile del settore immobiliare',
      'risk_engineer': 'Ingegnere di gestione dei rischi',
      'risk_manager': 'Responsabile della gestione dei rischi',
      'safety_manager': 'Responsabile della sicurezza',
      'scheduler': 'Pianificatore',
      'self_perform_foreman': 'Caposquadra autonomo',
      'services_engineer': 'Ingegnere dei servizi',
      'site_engineer': 'Ingegnere in cantiere',
      'site_manager': 'Responsabile cantiere',
      'site_supervisor': 'Supervisore cantiere',
      'structural_engineer': 'Ingegnere strutturale',
      'subcontractor': 'Subappaltatore',
      'superintendent': 'Sovrintendente',
      'surveyor': 'Topografo',
      'team_leader': 'Leader del team',
      'transportation_engineer': 'Ingegnere dei trasporti',
      'vdc_engineer': 'Ingegnere VDC',
      'vdc_manager': 'Responsabile VDC',
      'vp_quality': 'VP qualità',
      'vp_safety': 'VP sicurezza'
    }
  },
  'ja': {
    'topFolder': {
      'projectFiles': 'プロジェクト ファイル',
      'forTheField': '現場向け'
    },
    'permissions': {
      'everyone': 'すべてのメンバー'
    },
    'attributes': {
      'title': '件名',
      'number': '番号',
      'sheetNumber': 'シート番号',
      'project': 'プロジェクト',
      'originator': '開始者',
      'volumeSystem': 'ボリューム/システム',
      'levelLocation': 'レベル/場所',
      'type': 'タイプ',
      'role': '役割',
      'status': 'ステータス',
      'revision': '改訂',
      'classification': '分類'
    },
    'users': {
      'accSystem': 'ACC システム'
    },
    'userRoles': {
      'acoustical_engineer': '音響エンジニア',
      'architect': '建築設計者',
      'architectural_technician': '建築技術者',
      'architectural_technologist': '建築技師',
      'assistant_project_manager': 'アシスタント プロジェクト管理者',
      'assistant_superintendent': 'アシスタント現場監督',
      'bim_coordinator': 'BIM コーディネータ',
      'bim_engineer': 'BIM エンジニア',
      'bim_manager': 'BIM 管理者',
      'bim_technician': 'BIM 技術者',
      'building_inspector': '建築物検査担当者',
      'building_services_engineer': '建築物維持管理エンジニア',
      'building_supervisor': '建築物管理者',
      'building_surveyor': '建築物測量士',
      'business_development_manager': 'ビジネス開拓管理者',
      'buyer': '仕入れ担当者',
      'cad_operator': 'CAD オペレータ',
      'civil_engineer': '土木エンジニア',
      'commercial_manager': '販売管理者',
      'commissioning_manager': '試運転管理者',
      'construction_coordinator': '施工コーディネータ',
      'construction_manager': '施工管理者',
      'construction_technician': '施工コーディネータ',
      'consultant': 'コンサルタント',
      'contract_administrator': '契約管理者',
      'contract_manager': '契約管理者',
      'contractor': '請負業者',
      'coordinator': 'コーディネータ',
      'cost_engineer': 'コスト エンジニア',
      'cost_manager': 'コスト管理者',
      'defects_manager': '不具合管理者',
      'design_manager': '設計管理者',
      'designer': '意匠設計者',
      'director': '責任者',
      'director_of_design': '設計責任者',
      'director_of_operations': '業務責任者',
      'document_controller': 'ドキュメント管理者',
      'document_manager': 'ドキュメント管理者',
      'drafter': '製図者',
      'electrical_engineer': '電気エンジニア',
      'employers_agent': '人材担当者',
      'engineer': '構造設計者',
      'environmental_engineer': '環境エンジニア',
      'estimator': '積算担当者',
      'executive': '役員',
      'facilities_director': '設備責任者',
      'facilities_manager': '設備管理者',
      'field_controller': '現場管理者',
      'field_engineer': '現場エンジニア',
      'field_supervisor': '現場監督者',
      'field_viewer': '現場観察者(BIM Station/JOBOX)',
      'fire_safety_engineer': '防火エンジニア',
      'foreman': '現場主任',
      'hvac_engineer': 'HVAC エンジニア',
      'inspector': '検査担当者',
      'interior_architect': '屋内建築設計者',
      'interior_designer': 'インテリア デザイナー',
      'it': 'IT 管理者',
      'lighting_designer': '照明デザイナー',
      'managing_director': '管理責任者',
      'mechanical_engineer': '機械エンジニア',
      'mep_engineer': 'MEP エンジニア',
      'owner': 'オーナー',
      'owner_representative': 'オーナー・代表者',
      'planner': '立案者',
      'plumbing_engineer': '配管エンジニア',
      'principal_architect': '主任建築設計者',
      'process_engineer': 'プロセス エンジニア',
      'procurement': '調達担当者',
      'procurement_specialist': '調達専門家',
      'project_controls_engineer': 'プロジェクト コントロール エンジニア',
      'project_director': 'プロジェクト責任者',
      'project_engineer': 'プロジェクト エンジニア',
      'project_leader': 'プロジェクト リーダー',
      'project_manager': 'プロジェクト管理者',
      'purchasing_coordinator': '購入コーディネータ',
      'quality_manager': '品質管理者',
      'quantity_surveyor': '積算士',
      'real_estate_manager': '不動産管理者',
      'risk_engineer': 'リスク エンジニア',
      'risk_manager': 'リスク管理者',
      'safety_manager': '安全管理者',
      'scheduler': '工程管理者',
      'self_perform_foreman': '自己作業監督',
      'services_engineer': '維持管理エンジニア',
      'site_engineer': 'サイト エンジニア',
      'site_manager': 'サイト管理者',
      'site_supervisor': 'サイト監督者',
      'structural_engineer': '構造エンジニア',
      'subcontractor': '下請業者',
      'superintendent': '現場監督',
      'surveyor': '測量士',
      'team_leader': 'チーム リーダー',
      'transportation_engineer': '輸送エンジニア',
      'vdc_engineer': 'VDC エンジニア',
      'vdc_manager': 'VDC 管理者',
      'vp_quality': '品質責任者',
      'vp_safety': '安全責任者'
    }
  },
  'ko': {
    'topFolder': {
      'projectFiles': '프로젝트 파일',
      'forTheField': '필드인 경우'
    },
    'permissions': {
      'everyone': '모든 사용자'
    },
    'attributes': {
      'title': '제목',
      'number': '번호',
      'sheetNumber': '시트 번호',
      'project': '프로젝트',
      'originator': '원작성자',
      'volumeSystem': '볼륨/시스템',
      'levelLocation': '레벨/위치',
      'type': '유형',
      'role': '역할',
      'status': '상태',
      'revision': '리비전',
      'classification': '분류'
    },
    'users': {
      'accSystem': 'ACC 시스템'
    },
    'userRoles': {
      'acoustical_engineer': '흡음 엔지니어',
      'architect': '건축가',
      'architectural_technician': '건축 기술자',
      'architectural_technologist': '건축 전문 기술자',
      'assistant_project_manager': '보조 프로젝트 관리자',
      'assistant_superintendent': '보조 감독관',
      'bim_coordinator': 'BIM 담당자',
      'bim_engineer': 'BIM 엔지니어',
      'bim_manager': 'BIM 관리자',
      'bim_technician': 'BIM 기술자',
      'building_inspector': '건물 검사관',
      'building_services_engineer': '빌딩 서비스 엔지니어',
      'building_supervisor': '건물 감독',
      'building_surveyor': '건축 측량사',
      'business_development_manager': '비즈니스 개발 관리자',
      'buyer': '구매자',
      'cad_operator': 'CAD 연산자',
      'civil_engineer': '토목 기사',
      'commercial_manager': '상용 관리자',
      'commissioning_manager': '시운전 관리자',
      'construction_coordinator': '시공 담당자',
      'construction_manager': '건설 관리자',
      'construction_technician': '시공 기술자',
      'consultant': '컨설턴트',
      'contract_administrator': '계약 관리자',
      'contract_manager': '계약 관리자',
      'contractor': '도급사',
      'coordinator': '담당자',
      'cost_engineer': '원가 관리 엔지니어',
      'cost_manager': '원가 관리사',
      'defects_manager': '결함 관리자',
      'design_manager': '설계 관리자',
      'designer': '설계자',
      'director': '디렉터',
      'director_of_design': '설계 담당 이사',
      'director_of_operations': '운영 부분 디렉터',
      'document_controller': '문서 제어기',
      'document_manager': '문서 관리자',
      'drafter': '제도 담당자',
      'electrical_engineer': '전기 기사',
      'employers_agent': '고용주 대리인',
      'engineer': '엔지니어',
      'environmental_engineer': '환경 엔지니어',
      'estimator': '견적 담당자',
      'executive': '경영진',
      'facilities_director': '설비 디렉터',
      'facilities_manager': '설비 관리자',
      'field_controller': '필드 제어기',
      'field_engineer': '현장 엔지니어',
      'field_supervisor': '현장 감독자',
      'field_viewer': '필드 뷰어(BIM 스테이션/JOBOX용)',
      'fire_safety_engineer': '화재 안전 엔지니어',
      'foreman': '감독관',
      'hvac_engineer': 'HVAC 엔지니어',
      'inspector': '감독관',
      'interior_architect': '인테리어 건축가',
      'interior_designer': '내부 설계자',
      'it': 'IT',
      'lighting_designer': '조명 디자이너',
      'managing_director': '상무이사',
      'mechanical_engineer': '기계 엔지니어',
      'mep_engineer': 'MEP 엔지니어',
      'owner': '소유자',
      'owner_representative': '소유자 담당자',
      'planner': '계획자',
      'plumbing_engineer': '배관 엔지니어',
      'principal_architect': '대표 건축가',
      'process_engineer': '공정 엔지니어',
      'procurement': '조달',
      'procurement_specialist': '구매 전문가',
      'project_controls_engineer': '프로젝트 제어 엔지니어',
      'project_director': '프로젝트 디렉터',
      'project_engineer': '프로젝트 엔지니어',
      'project_leader': '프로젝트 지시선',
      'project_manager': '프로젝트 관리자',
      'purchasing_coordinator': '구매 담당자',
      'quality_manager': '품질 관리자',
      'quantity_surveyor': '견적사',
      'real_estate_manager': '부동산 관리자',
      'risk_engineer': '위험 엔지니어',
      'risk_manager': '위험 관리자',
      'safety_manager': '안전 관리자',
      'scheduler': '일정',
      'self_perform_foreman': '현장 주임',
      'services_engineer': '서비스 엔지니어',
      'site_engineer': '현장 엔지니어',
      'site_manager': '사이트 관리자',
      'site_supervisor': '사이트 감독자',
      'structural_engineer': '구조 엔지니어',
      'subcontractor': '하청업체',
      'superintendent': '감독관',
      'surveyor': '측량사',
      'team_leader': '팀 리더',
      'transportation_engineer': '운송 엔지니어',
      'vdc_engineer': 'VDC 엔지니어',
      'vdc_manager': 'VDC 관리자',
      'vp_quality': 'VP 품질',
      'vp_safety': 'VP 안전'
    }
  },
  'nl': {
    'topFolder': {
      'projectFiles': 'Projectbestanden',
      'forTheField': 'Voor het veld'
    },
    'permissions': {
      'everyone': 'Iedereen'
    },
    'attributes': {
      'title': 'Titel',
      'number': 'Nummer',
      'sheetNumber': 'Bouwtekeningnummer',
      'project': 'Project',
      'originator': 'Starter',
      'volumeSystem': 'Volume/Systeem',
      'levelLocation': 'Niveau/Locatie',
      'type': 'Type',
      'role': 'Rol',
      'status': 'Status',
      'revision': 'Herziening',
      'classification': 'Classificatie'
    },
    'users': {
      'accSystem': 'ACC-systeem'
    },
    'userRoles': {
      'acoustical_engineer': 'Akoestisch ingenieur',
      'architect': 'Architect',
      'architectural_technician': 'Architectonische technicus',
      'architectural_technologist': 'Architectonische technoloog',
      'assistant_project_manager': 'Assistent-projectmanager',
      'assistant_superintendent': 'Assistent-opzichter',
      'bim_coordinator': 'BIM-coördinator',
      'bim_engineer': 'BIM-ingenieur',
      'bim_manager': 'BIM-manager',
      'bim_technician': 'BIM-technicus',
      'building_inspector': 'Bouwinspecteur',
      'building_services_engineer': 'Bouwdiensten ingenieur',
      'building_supervisor': 'Bouwleidinggevende',
      'building_surveyor': 'Bouwlandmeter',
      'business_development_manager': 'Bedrijfontwikkelingsmanager',
      'buyer': 'Afnemer',
      'cad_operator': 'CAD-operator',
      'civil_engineer': 'Civiel ingenieur',
      'commercial_manager': 'Commercieel manager',
      'commissioning_manager': 'Inbedrijfstellingsmanager',
      'construction_coordinator': 'Bouwcoördinator',
      'construction_manager': 'Bouwmanager',
      'construction_technician': 'Bouwtechnicus',
      'consultant': 'Consultant',
      'contract_administrator': 'Contractbeheerder',
      'contract_manager': 'Contractmanager',
      'contractor': 'Aannemer',
      'coordinator': 'Coördinator',
      'cost_engineer': 'Kosteningenieur',
      'cost_manager': 'Kostenmanager',
      'defects_manager': 'Defectenmanager',
      'design_manager': 'Ontwerpmanager',
      'designer': 'Ontwerper',
      'director': 'Directeur',
      'director_of_design': 'Ontwerpdirecteur',
      'director_of_operations': 'Uitvoerend directeur',
      'document_controller': 'Documentcontroleur',
      'document_manager': 'Documentmanager',
      'drafter': 'Technisch tekenaar',
      'electrical_engineer': 'Elektrotechnisch ingenieur',
      'employers_agent': 'Werkgeversagent',
      'engineer': 'Ingenieur',
      'environmental_engineer': 'Milieutechnicus',
      'estimator': 'Calculator',
      'executive': 'Leidinggevende',
      'facilities_director': 'Faciliteitdirecteur',
      'facilities_manager': 'Faciliteitmanager',
      'field_controller': 'Veldcontroleur',
      'field_engineer': 'Veldingenieur',
      'field_supervisor': 'Veldleidinggevende',
      'field_viewer': 'Veldopzichter (voor BIM Station/JOBOX)',
      'fire_safety_engineer': 'Brandveiligheidsingenieur',
      'foreman': 'Voorman',
      'hvac_engineer': 'HVAC-ingenieur',
      'inspector': 'Inspecteur',
      'interior_architect': 'Interieurarchitect',
      'interior_designer': 'Interieurontwerper',
      'it': 'IT',
      'lighting_designer': 'Lichtontwerper',
      'managing_director': 'Directeur',
      'mechanical_engineer': 'Werktuigbouwkundig ingenieur',
      'mep_engineer': 'MEP-ingenieur',
      'owner': 'Eigenaar',
      'owner_representative': 'Eigenaarvertegenwoordiger',
      'planner': 'Planner',
      'plumbing_engineer': 'Sanitair ingenieur',
      'principal_architect': 'Hoofdarchitect',
      'process_engineer': 'Procesingenieur',
      'procurement': 'Inkoop',
      'procurement_specialist': 'Inkoopspecialist',
      'project_controls_engineer': 'Projectbesturingsingenieur',
      'project_director': 'Projectdirecteur',
      'project_engineer': 'Projectingenieur',
      'project_leader': 'Projectleider',
      'project_manager': 'Projectmanager',
      'purchasing_coordinator': 'Aankopencoördinator',
      'quality_manager': 'Kwaliteitsmanager',
      'quantity_surveyor': 'Hoeveelheidsopzichter',
      'real_estate_manager': 'Vastgoedbeheerder',
      'risk_engineer': 'Risicotechnicus',
      'risk_manager': 'Risicomanager',
      'safety_manager': 'Veiligheidsmanager',
      'scheduler': 'Planner',
      'self_perform_foreman': 'Zelfstandige voorman',
      'services_engineer': 'Dienstingenieur',
      'site_engineer': 'Veldingenieur',
      'site_manager': 'Veldmanager',
      'site_supervisor': 'Veldleidinggevende',
      'structural_engineer': 'Bouwkundig ingenieur',
      'subcontractor': 'Onderaannemer',
      'superintendent': 'Opzichter',
      'surveyor': 'Landmeetkundige',
      'team_leader': 'Teamleider',
      'transportation_engineer': 'Transportingenieur',
      'vdc_engineer': 'VDC-ingenieur',
      'vdc_manager': 'VDC-manager',
      'vp_quality': 'VP-kwaliteit',
      'vp_safety': 'VP-veiligheid'
    }
  },
  'no': {
    'topFolder': {
      'projectFiles': 'Prosjektfiler',
      'forTheField': 'For byggeplass'
    },
    'permissions': {
      'everyone': 'Alle'
    },
    'attributes': {
      'title': 'Tittel',
      'number': 'Nummer',
      'sheetNumber': 'Arknummer',
      'project': 'Prosjekt',
      'originator': 'Avsender',
      'volumeSystem': 'Volum/system',
      'levelLocation': 'Nivå/plassering',
      'type': 'Type',
      'role': 'Rolle',
      'status': 'Status',
      'revision': 'Revisjon',
      'classification': 'Klassifisering'
    },
    'users': {
      'accSystem': 'ACC-system'
    },
    'userRoles': {
      'acoustical_engineer': 'Akustisk ingeniør',
      'architect': 'Arkitekt',
      'architectural_technician': 'Arkitektonisk tekniker',
      'architectural_technologist': 'Arkitektonisk teknolog',
      'assistant_project_manager': 'Assisterende prosjektadministrator',
      'assistant_superintendent': 'Assisterende inspektør',
      'bim_coordinator': 'BIM-koordinator',
      'bim_engineer': 'BIM-ingeniør',
      'bim_manager': 'BIM-leder',
      'bim_technician': 'BIM-tekniker',
      'building_inspector': 'Bygginspektør',
      'building_services_engineer': 'Byggtjeneste-ingeniør',
      'building_supervisor': 'Byggeveileder',
      'building_surveyor': 'Byggmåler',
      'business_development_manager': 'Forretningsutviklingsleder',
      'buyer': 'Kjøper',
      'cad_operator': 'CAD-operatør',
      'civil_engineer': 'Sivilingeniør',
      'commercial_manager': 'Kommersiell leder',
      'commissioning_manager': 'Leder for igangsetting',
      'construction_coordinator': 'Byggekoordinator',
      'construction_manager': 'Byggeleder',
      'construction_technician': 'Byggtekniker',
      'consultant': 'Konsulent',
      'contract_administrator': 'Kontraktadministrator',
      'contract_manager': 'Kontraktleder',
      'contractor': 'Entreprenør',
      'coordinator': 'Koordinator',
      'cost_engineer': 'Kostnadsingeniør',
      'cost_manager': 'Budsjettansvarlig',
      'defects_manager': 'Feilansvarlig',
      'design_manager': 'Designansvarlig',
      'designer': 'Designer',
      'director': 'Direktør',
      'director_of_design': 'Designansvarlig',
      'director_of_operations': 'Driftsansvarlig',
      'document_controller': 'Dokumentkontroller',
      'document_manager': 'Dokumentansvarlig',
      'drafter': 'Tegner',
      'electrical_engineer': 'Elektroingeniør',
      'employers_agent': 'Arbeidsgiveragent',
      'engineer': 'Ingeniør',
      'environmental_engineer': 'Miljøingeniør',
      'estimator': 'Beregner',
      'executive': 'Leder',
      'facilities_director': 'Fasilitetsdirektør',
      'facilities_manager': 'Fasilitetsansvarlig',
      'field_controller': 'Feltkontroller',
      'field_engineer': 'Feltingeniør',
      'field_supervisor': 'Feltveileder',
      'field_viewer': 'Feltvisning (for BIM Station/JOBOX)',
      'fire_safety_engineer': 'Brannsikkerhetsingeniør',
      'foreman': 'Formann',
      'hvac_engineer': 'VVS-ingeniør',
      'inspector': 'Inspektør',
      'interior_architect': 'Interiørarkitekt',
      'interior_designer': 'Interiørdesigner',
      'it': 'IT',
      'lighting_designer': 'Lysdesigner',
      'managing_director': 'Administrerende direktør',
      'mechanical_engineer': 'Mekanisk ingeniør',
      'mep_engineer': 'MEP-ingeniør',
      'owner': 'Eier',
      'owner_representative': 'Eierrepresentant',
      'planner': 'Planlegger',
      'plumbing_engineer': 'Rørlegger',
      'principal_architect': 'Hovedarkitekt',
      'process_engineer': 'Prosessingeniør',
      'procurement': 'Innkjøp',
      'procurement_specialist': 'Innkjøpsansvarlig',
      'project_controls_engineer': 'Prosjektstyringsingeniør',
      'project_director': 'Prosjektleder',
      'project_engineer': 'Prosjektingeniør',
      'project_leader': 'Prosjektleder',
      'project_manager': 'Prosjektleder',
      'purchasing_coordinator': 'Innkjøpskoordinator',
      'quality_manager': 'Kvalitetsleder',
      'quantity_surveyor': 'Mengdemåler',
      'real_estate_manager': 'Eiendomssjef',
      'risk_engineer': 'Risikotekniker',
      'risk_manager': 'Risikoleder',
      'safety_manager': 'Sikkerhetsansvarlig',
      'scheduler': 'Planlegger',
      'self_perform_foreman': 'Arbeidende formann',
      'services_engineer': 'Tjenesteingeniør',
      'site_engineer': 'Anleggsingeniør',
      'site_manager': 'Anleggsansvarlig',
      'site_supervisor': 'Anleggsveileder',
      'structural_engineer': 'Bygningsingeniør',
      'subcontractor': 'Underentreprenør',
      'superintendent': 'Inspektør',
      'surveyor': 'Landmåler',
      'team_leader': 'Teamleder',
      'transportation_engineer': 'Transportingeniør',
      'vdc_engineer': 'VDC-ingeniør',
      'vdc_manager': 'VDC-leder',
      'vp_quality': 'VP-kvalitet',
      'vp_safety': 'VP-sikkerhet'
    }
  },
  'pl': {
    'topFolder': {
      'projectFiles': 'Pliki projektu',
      'forTheField': 'Prace w terenie'
    },
    'permissions': {
      'everyone': 'Wszyscy'
    },
    'attributes': {
      'title': 'Tytuł',
      'number': 'Numer',
      'sheetNumber': 'Numer arkusza',
      'project': 'Projekt',
      'originator': 'Twórca',
      'volumeSystem': 'Objętość/system',
      'levelLocation': 'Poziom/Położenie',
      'type': 'Typ',
      'role': 'Rola',
      'status': 'Stan',
      'revision': 'Rewizja',
      'classification': 'Klasyfikacja'
    },
    'users': {
      'accSystem': 'System ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Inżynier akustyk',
      'architect': 'Architekt',
      'architectural_technician': 'Technik działu architektonicznego',
      'architectural_technologist': 'Technolog działu architektonicznego',
      'assistant_project_manager': 'Zastępca kierownika projektu',
      'assistant_superintendent': 'Zastępca nadzorcy',
      'bim_coordinator': 'Koordynator BIM',
      'bim_engineer': 'Inżynier BIM',
      'bim_manager': 'Menedżer BIM',
      'bim_technician': 'Technik BIM',
      'building_inspector': 'Inspektor budownictwa',
      'building_services_engineer': 'Inżynier usług budowlanych',
      'building_supervisor': 'Kierownik ds. budownictwa',
      'building_surveyor': 'Specjalista ds. obmiarów budynku',
      'business_development_manager': 'Menedżer ds. rozwoju działalności',
      'buyer': 'Kupiec',
      'cad_operator': 'Operator CAD',
      'civil_engineer': 'Inżynier budownictwa',
      'commercial_manager': 'Kierownik ds. handlowych',
      'commissioning_manager': 'Kierownik ds. odbiorów',
      'construction_coordinator': 'Koordynator budowy',
      'construction_manager': 'Kierownik budowy',
      'construction_technician': 'Technik budowlany',
      'consultant': 'Konsultant',
      'contract_administrator': 'Administrator umów',
      'contract_manager': 'Kierownik ds. umów',
      'contractor': 'Wykonawca',
      'coordinator': 'Koordynator',
      'cost_engineer': 'Inżynier ds. kosztów',
      'cost_manager': 'Kierownik ds. kosztów',
      'defects_manager': 'Kierownik ds. usterek',
      'design_manager': 'Menedżer projektant',
      'designer': 'Projektant',
      'director': 'Dyrektor',
      'director_of_design': 'Dyrektor ds. projektowania',
      'director_of_operations': 'Dyrektor ds. operacyjnych',
      'document_controller': 'Kontroler dokumentów',
      'document_manager': 'Kierownik ds. dokumentów',
      'drafter': 'Kreślarz',
      'electrical_engineer': 'Inżynier elektryk',
      'employers_agent': 'Agent pracowników',
      'engineer': 'Inżynier',
      'environmental_engineer': 'Inżynier ochrony środowiska',
      'estimator': 'Kosztorysant',
      'executive': 'Dyrektor wykonawczy',
      'facilities_director': 'Dyrektor ds. obiektów',
      'facilities_manager': 'Menedżer obiektów',
      'field_controller': 'Kontroler terenowy',
      'field_engineer': 'Inżynier terenowy',
      'field_supervisor': 'Kierownik terenowy',
      'field_viewer': 'Osoba wyświetlająca w terenie (na potrzeby BIM Station / JOBOX)',
      'fire_safety_engineer': 'Inżynier ds. bezpieczeństwa pożarowego',
      'foreman': 'Majster',
      'hvac_engineer': 'Inżynier ds. HVAC',
      'inspector': 'Kontroler',
      'interior_architect': 'Architekt wnętrz',
      'interior_designer': 'Projektant wnętrz',
      'it': 'IT',
      'lighting_designer': 'Projektant oświetlenia',
      'managing_director': 'Dyrektor zarządzający',
      'mechanical_engineer': 'Inżynier mechanik',
      'mep_engineer': 'Inżynier instalacji',
      'owner': 'Właściciel',
      'owner_representative': 'Przedstawiciel właściciela',
      'planner': 'Planista',
      'plumbing_engineer': 'Inżynier instalacji wodno-kanalizacyjnych',
      'principal_architect': 'Główny architekt',
      'process_engineer': 'Inżynier ds. procesów',
      'procurement': 'Zaopatrzenie',
      'procurement_specialist': 'Specjalista ds. zaopatrzenia',
      'project_controls_engineer': 'Inżynier ds. kontroli projektu',
      'project_director': 'Dyrektor projektu',
      'project_engineer': 'Inżynier projektu',
      'project_leader': 'Lider projektu',
      'project_manager': 'Kierownik projektu',
      'purchasing_coordinator': 'Koordynator zakupów',
      'quality_manager': 'Menedżer ds. jakości',
      'quantity_surveyor': 'Specjalista ds. obmiarów',
      'real_estate_manager': 'Menedżer nieruchomości',
      'risk_engineer': 'Inżynier ds. ryzyka',
      'risk_manager': 'Menedżer ds. ryzyka',
      'safety_manager': 'Menedżer ds. bezpieczeństwa',
      'scheduler': 'Specjalista ds. harmonogramu',
      'self_perform_foreman': 'Samodzielny majster',
      'services_engineer': 'Inżynier usług',
      'site_engineer': 'Inżynier placu budowy',
      'site_manager': 'Menedżer placu budowy',
      'site_supervisor': 'Kierownik placu budowy',
      'structural_engineer': 'Inżynier budownictwa',
      'subcontractor': 'Podwykonawca',
      'superintendent': 'Nadzorca',
      'surveyor': 'Geodeta',
      'team_leader': 'Lider zespołu',
      'transportation_engineer': 'Inżynier ds. transportu',
      'vdc_engineer': 'Inżynier VDC',
      'vdc_manager': 'Menedżer VDC',
      'vp_quality': 'Wiceprezes ds. jakości',
      'vp_safety': 'Wiceprezes ds. jakości'
    }
  },
  'pt-BR': {
    'topFolder': {
      'projectFiles': 'Arquivos de projeto',
      'forTheField': 'Para o campo'
    },
    'permissions': {
      'everyone': 'Todos'
    },
    'attributes': {
      'title': 'Título',
      'number': 'Número',
      'sheetNumber': 'Número da folha',
      'project': 'Projeto',
      'originator': 'Originador',
      'volumeSystem': 'Volume/sistema',
      'levelLocation': 'Nível/localização',
      'type': 'Tipo',
      'role': 'Função',
      'status': 'Status',
      'revision': 'Revisão',
      'classification': 'Classificação'
    },
    'users': {
      'accSystem': 'Sistema ACC'
    },
    'userRoles': {
      'acoustical_engineer': 'Engenheiro acústico',
      'architect': 'Arquiteto',
      'architectural_technician': 'Técnico de arquitetura',
      'architectural_technologist': 'Tecnólogo de arquitetura',
      'assistant_project_manager': 'Gerente de projetos assistente',
      'assistant_superintendent': 'Superintendente assistente',
      'bim_coordinator': 'Coordenador do BIM',
      'bim_engineer': 'Engenheiro do BIM',
      'bim_manager': 'Gerente de BIM',
      'bim_technician': 'Técnico do BIM',
      'building_inspector': 'Inspetor de construção',
      'building_services_engineer': 'Engenheiro de serviços de construção',
      'building_supervisor': 'Supervisor de construção',
      'building_surveyor': 'Topógrafo de construção',
      'business_development_manager': 'Gerente de desenvolvimento de negócios',
      'buyer': 'Comprador',
      'cad_operator': 'Operador de CAD',
      'civil_engineer': 'Engenheiro civil',
      'commercial_manager': 'Gerente comercial',
      'commissioning_manager': 'Gerente de comissionamento',
      'construction_coordinator': 'Coordenador de construção',
      'construction_manager': 'Gerente de construção',
      'construction_technician': 'Técnico de construção',
      'consultant': 'Consultor',
      'contract_administrator': 'Administrador de contratos',
      'contract_manager': 'Gerente de contratos',
      'contractor': 'Empreiteiro',
      'coordinator': 'Coordenador',
      'cost_engineer': 'Engenheiro de custos',
      'cost_manager': 'Gerente de custos',
      'defects_manager': 'Gerenciador de defeitos',
      'design_manager': 'Gerente de projetos',
      'designer': 'Projetista',
      'director': 'Diretor',
      'director_of_design': 'Diretor de projetos',
      'director_of_operations': 'Diretor de operações',
      'document_controller': 'Controlador de documentos',
      'document_manager': 'Gerenciador de documentos',
      'drafter': 'Desenhista',
      'electrical_engineer': 'Engenheiro elétrico',
      'employers_agent': 'Agente de empregadores',
      'engineer': 'Engenheiro',
      'environmental_engineer': 'Engenheiro ambiental',
      'estimator': 'Avaliador',
      'executive': 'Executivo',
      'facilities_director': 'Diretor das instalações',
      'facilities_manager': 'Gerente das instalações',
      'field_controller': 'Controlador de campo',
      'field_engineer': 'Engenheiro de campo',
      'field_supervisor': 'Supervisor de campo',
      'field_viewer': 'Visualizador de campo (para BIM Station/JOBOX)',
      'fire_safety_engineer': 'Engenheiro de segurança contra incêndio',
      'foreman': 'Chefe',
      'hvac_engineer': 'Engenheiro de AVAC',
      'inspector': 'Inspetor',
      'interior_architect': 'Arquiteto de interiores',
      'interior_designer': 'Designer de interiores',
      'it': 'TI',
      'lighting_designer': 'Projetista de iluminação',
      'managing_director': 'Diretor executivo',
      'mechanical_engineer': 'Engenheiro mecânico',
      'mep_engineer': 'Engenheiro MEP',
      'owner': 'Proprietário',
      'owner_representative': 'Representante do proprietário',
      'planner': 'Planejador',
      'plumbing_engineer': 'Engenheiro hidráulico',
      'principal_architect': 'Arquiteto principal',
      'process_engineer': 'Engenheiro de processos',
      'procurement': 'Aquisição',
      'procurement_specialist': 'Especialista de aquisição',
      'project_controls_engineer': 'Engenheiro de controles do projeto',
      'project_director': 'Diretor de projetos',
      'project_engineer': 'Engenheiro de projeto',
      'project_leader': 'Líder de projeto',
      'project_manager': 'Gerente de projeto',
      'purchasing_coordinator': 'Coordenador de compras',
      'quality_manager': 'Gerente de qualidade',
      'quantity_surveyor': 'Medidor-orçamentista',
      'real_estate_manager': 'Gerente imobiliário',
      'risk_engineer': 'Engenheiro de riscos',
      'risk_manager': 'Gerente de riscos',
      'safety_manager': 'Gerente de segurança',
      'scheduler': 'Agendador',
      'self_perform_foreman': 'Capataz independente',
      'services_engineer': 'Engenheiro de serviços',
      'site_engineer': 'Engenheiro de obra',
      'site_manager': 'Gerente de obra',
      'site_supervisor': 'Supervisor de obra',
      'structural_engineer': 'Engenheiro estrutural',
      'subcontractor': 'Subempreiteiro',
      'superintendent': 'Superintendente',
      'surveyor': 'Topógrafo',
      'team_leader': 'Líder da equipe',
      'transportation_engineer': 'Engenheiro de transporte',
      'vdc_engineer': 'Engenheiro de projeto e construção virtual',
      'vdc_manager': 'Gerente de projeto e construção virtual',
      'vp_quality': 'Vice-presidente de qualidade',
      'vp_safety': 'Vice-presidente de segurança'
    }
  },
  'sv': {
    'topFolder': {
      'projectFiles': 'Projektfiler',
      'forTheField': 'För fältet'
    },
    'permissions': {
      'everyone': 'Alla'
    },
    'attributes': {
      'title': 'Rubrik',
      'number': 'Nummer',
      'sheetNumber': 'Ritbladsnummer',
      'project': 'Projekt',
      'originator': 'Upphovsman',
      'volumeSystem': 'Volym/system',
      'levelLocation': 'Nivå/plats',
      'type': 'Typ',
      'role': 'Roll',
      'status': 'Status',
      'revision': 'Ändring',
      'classification': 'Klassificering'
    },
    'users': {
      'accSystem': 'ACC-system'
    },
    'userRoles': {
      'acoustical_engineer': 'Akustisk tekniker',
      'architect': 'Arkitekt',
      'architectural_technician': 'Arkitektonisk tekniker',
      'architectural_technologist': 'Arkitektonisk teknolog',
      'assistant_project_manager': 'Biträdande projektansvarig',
      'assistant_superintendent': 'Biträdande föreståndare',
      'bim_coordinator': 'BIM-koordinator',
      'bim_engineer': 'BIM-ingenjör',
      'bim_manager': 'BIM-ansvarig',
      'bim_technician': 'BIM-tekniker',
      'building_inspector': 'Byggnadsinspektör',
      'building_services_engineer': 'Byggnadstekniker',
      'building_supervisor': 'Byggnadshandledare',
      'building_surveyor': 'Byggnadsinspektör',
      'business_development_manager': 'Affärsutvecklingschef',
      'buyer': 'Inköpare',
      'cad_operator': 'CAD-operatör',
      'civil_engineer': 'Civilingenjör',
      'commercial_manager': 'Kommersiell chef',
      'commissioning_manager': 'Driftansvarig',
      'construction_coordinator': 'Byggkoordinator',
      'construction_manager': 'Byggchef',
      'construction_technician': 'Byggtekniker',
      'consultant': 'Konsult',
      'contract_administrator': 'Avtalsadministratör',
      'contract_manager': 'Kontraktschef',
      'contractor': 'Entreprenör',
      'coordinator': 'Koordinator',
      'cost_engineer': 'Kostnadsingenjör',
      'cost_manager': 'Kostnadschef',
      'defects_manager': 'Defektansvarig',
      'design_manager': 'Designansvarig',
      'designer': 'Designer',
      'director': 'Chef',
      'director_of_design': 'Designchef',
      'director_of_operations': 'Verksamhetschef',
      'document_controller': 'Dokumentkontrollant',
      'document_manager': 'Dokumenthanterare',
      'drafter': 'Redaktör',
      'electrical_engineer': 'Eltekniker',
      'employers_agent': 'Arbetsgivaragent',
      'engineer': 'Ingenjör',
      'environmental_engineer': 'Miljötekniker',
      'estimator': 'Uppskattare',
      'executive': 'Chef',
      'facilities_director': 'Anläggningschef',
      'facilities_manager': 'Anläggningsansvarig',
      'field_controller': 'Fältkontrollant',
      'field_engineer': 'Fälttekniker',
      'field_supervisor': 'Fältansvarig',
      'field_viewer': 'Field Viewer (för BIM Station/JOBOX)',
      'fire_safety_engineer': 'Brandsäkerhetstekniker',
      'foreman': 'Förman',
      'hvac_engineer': 'HVAC-tekniker',
      'inspector': 'Inspektör',
      'interior_architect': 'Inredningsarkitekt',
      'interior_designer': 'Inredningsdesigner',
      'it': 'IT',
      'lighting_designer': 'Belysningsdesigner',
      'managing_director': 'VD',
      'mechanical_engineer': 'Maskintekniker',
      'mep_engineer': 'MEP-tekniker',
      'owner': 'Byggherre',
      'owner_representative': 'Byggherre-representant',
      'planner': 'Planerare',
      'plumbing_engineer': 'VVS-tekniker',
      'principal_architect': 'Huvudarkitekt',
      'process_engineer': 'Processtekniker',
      'procurement': 'Anskaffning',
      'procurement_specialist': 'Anskaffningsspecialist',
      'project_controls_engineer': 'Projektkontrolltekniker',
      'project_director': 'Projektchef',
      'project_engineer': 'Projektkonstruktör',
      'project_leader': 'Projektledare',
      'project_manager': 'Projektansvarig',
      'purchasing_coordinator': 'Inköpskoordinator',
      'quality_manager': 'Kvalitetsansvarig',
      'quantity_surveyor': 'Kvalitetsinspektör',
      'real_estate_manager': 'Fastighetschef',
      'risk_engineer': 'Risktekniker',
      'risk_manager': 'Riskansvarig',
      'safety_manager': 'Arbetsmiljöansvarig',
      'scheduler': 'Schemaläggare',
      'self_perform_foreman': 'Självutförande förman',
      'services_engineer': 'Servicetekniker',
      'site_engineer': 'Platstekniker',
      'site_manager': 'Platsansvarig',
      'site_supervisor': 'Platshandledare',
      'structural_engineer': 'Byggnadsingenjör',
      'subcontractor': 'Underentreprenör',
      'superintendent': 'Platschef',
      'surveyor': 'Besiktningsman',
      'team_leader': 'Teamledare',
      'transportation_engineer': 'Transporttekniker',
      'vdc_engineer': 'VDC-tekniker',
      'vdc_manager': 'VDC-ansvarig',
      'vp_quality': 'VP-kvalitet',
      'vp_safety': 'VP-arbetsmiljö'
    }
  },
  'zh-Hans': {
    'topFolder': {
      'projectFiles': '项目文件',
      'forTheField': '供现场工作人员使用'
    },
    'permissions': {
      'everyone': '所有人'
    },
    'attributes': {
      'title': '标题',
      'number': '编号',
      'sheetNumber': '图纸编号',
      'project': '项目',
      'originator': '创始人',
      'volumeSystem': '卷/系统',
      'levelLocation': '级别/位置',
      'type': '类型',
      'role': '角色',
      'status': '状态',
      'revision': '修订',
      'classification': '分类'
    },
    'users': {
      'accSystem': 'ACC 系统'
    },
    'userRoles': {
      'acoustical_engineer': '隔音工程师',
      'architect': '建筑师',
      'architectural_technician': '建筑技术人员',
      'architectural_technologist': '建筑设计师',
      'assistant_project_manager': '项目经理助理',
      'assistant_superintendent': '负责人助理',
      'bim_coordinator': 'BIM 协调员',
      'bim_engineer': 'BIM 工程师',
      'bim_manager': 'BIM 经理',
      'bim_technician': 'BIM 技术人员',
      'building_inspector': '建筑检查员',
      'building_services_engineer': '建筑服务工程师',
      'building_supervisor': '建筑主管',
      'building_surveyor': '建筑勘测员',
      'business_development_manager': '业务开发经理',
      'buyer': '采购员',
      'cad_operator': 'CAD 操作员',
      'civil_engineer': '土木工程师',
      'commercial_manager': '商务经理',
      'commissioning_manager': '调试经理',
      'construction_coordinator': '施工协调员',
      'construction_manager': '施工经理',
      'construction_technician': '施工技术人员',
      'consultant': '顾问',
      'contract_administrator': '合同管理员',
      'contract_manager': '合同经理',
      'contractor': '承包商',
      'coordinator': '协调员',
      'cost_engineer': '成本工程师',
      'cost_manager': '成本经理',
      'defects_manager': '缺陷经理',
      'design_manager': '设计经理',
      'designer': '设计师',
      'director': '主管',
      'director_of_design': '设计总监',
      'director_of_operations': '运营总监',
      'document_controller': '文档控制员',
      'document_manager': '文档管理员',
      'drafter': '绘图员',
      'electrical_engineer': '电气工程师',
      'employers_agent': '雇主代理',
      'engineer': '工程师',
      'environmental_engineer': '环境工程师',
      'estimator': '预算员',
      'executive': '执行人',
      'facilities_director': '设施负责人',
      'facilities_manager': '设施经理',
      'field_controller': '现场控制员',
      'field_engineer': '现场工程师',
      'field_supervisor': '现场主管',
      'field_viewer': '现场监察人员(对于 BIM Station / JOBOX)',
      'fire_safety_engineer': '防火工程师',
      'foreman': '领班',
      'hvac_engineer': 'HVAC 工程师',
      'inspector': '检验员',
      'interior_architect': '室内建筑师',
      'interior_designer': '室内设计师',
      'it': 'IT',
      'lighting_designer': '照明设计师',
      'managing_director': '总经理',
      'mechanical_engineer': '机械工程师',
      'mep_engineer': 'MEP 工程师',
      'owner': '业主',
      'owner_representative': '业主代表',
      'planner': '规划师',
      'plumbing_engineer': '管道工程师',
      'principal_architect': '首席建筑师',
      'process_engineer': '工艺工程师',
      'procurement': '采购',
      'procurement_specialist': '采购专家',
      'project_controls_engineer': '项目控制工程师',
      'project_director': '项目主管',
      'project_engineer': '项目工程师',
      'project_leader': '项目负责人',
      'project_manager': '项目经理',
      'purchasing_coordinator': '采购协调员',
      'quality_manager': '质量经理',
      'quantity_surveyor': '工料测量师',
      'real_estate_manager': '房地产经理',
      'risk_engineer': '风险工程师',
      'risk_manager': '风险经理',
      'safety_manager': '安全经理',
      'scheduler': '调度员',
      'self_perform_foreman': '自主工作的工长',
      'services_engineer': '服务工程师',
      'site_engineer': '场地工程师',
      'site_manager': '场地经理',
      'site_supervisor': '场地主管',
      'structural_engineer': '结构工程师',
      'subcontractor': '分包商',
      'superintendent': '负责人',
      'surveyor': '测量员',
      'team_leader': '团队负责人',
      'transportation_engineer': '运输工程师',
      'vdc_engineer': 'VDC 工程师',
      'vdc_manager': 'VDC 经理',
      'vp_quality': '质量副总裁',
      'vp_safety': '安全副总裁'
    }
  },
  'zh-Hant': {
    'topFolder': {
      'projectFiles': '專案檔案',
      'forTheField': '用於工地現場'
    },
    'permissions': {
      'everyone': '所有人'
    },
    'attributes': {
      'title': '標題',
      'number': '編號',
      'sheetNumber': '圖紙編號',
      'project': '專案',
      'originator': '發起人',
      'volumeSystem': '總量/系統',
      'levelLocation': '樓層/位置',
      'type': '類型',
      'role': '角色',
      'status': '狀態',
      'revision': '修訂',
      'classification': '分類'
    },
    'users': {
      'accSystem': 'ACC 系統'
    },
    'userRoles': {
      'acoustical_engineer': '聲學工程師',
      'architect': '建築師',
      'architectural_technician': '建築技師',
      'architectural_technologist': '建築技術專家',
      'assistant_project_manager': '副專案經理',
      'assistant_superintendent': '副主管',
      'bim_coordinator': 'BIM 協調員',
      'bim_engineer': 'BIM 工程師',
      'bim_manager': 'BIM 經理',
      'bim_technician': 'BIM 技師',
      'building_inspector': '建築檢查人員',
      'building_services_engineer': '建築服務工程師',
      'building_supervisor': '大樓管理員',
      'building_surveyor': '建築測量員',
      'business_development_manager': '業務開發經理',
      'buyer': '採購人員',
      'cad_operator': 'CAD 作業員',
      'civil_engineer': '土木工程師',
      'commercial_manager': '商務經理',
      'commissioning_manager': '試運轉經理',
      'construction_coordinator': '營造協調員',
      'construction_manager': '營造經理',
      'construction_technician': '營造技師',
      'consultant': '顧問',
      'contract_administrator': '約聘行政人員',
      'contract_manager': '約聘經理',
      'contractor': '約聘人員',
      'coordinator': '協調員',
      'cost_engineer': '成本工程師',
      'cost_manager': '成本經理',
      'defects_manager': '品管經理',
      'design_manager': '設計經理',
      'designer': '設計師',
      'director': '總監',
      'director_of_design': '設計總監',
      'director_of_operations': '營運總監',
      'document_controller': '文件管理師',
      'document_manager': '文件管理員',
      'drafter': '製圖師',
      'electrical_engineer': '電子工程師',
      'employers_agent': '雇主代理人',
      'engineer': '工程師',
      'environmental_engineer': '環境工程師',
      'estimator': '估算員',
      'executive': '主管',
      'facilities_director': '設施總監',
      'facilities_manager': '設施經理',
      'field_controller': '現場管理員',
      'field_engineer': '現場工程師',
      'field_supervisor': '現場主管',
      'field_viewer': '現場觀察員 (適用於 BIM Station/JOBOX)',
      'fire_safety_engineer': '消防安全工程師',
      'foreman': '工頭',
      'hvac_engineer': '暖通空調工程師',
      'inspector': '檢查員',
      'interior_architect': '室內建築師',
      'interior_designer': '室內設計師',
      'it': 'IT 人員',
      'lighting_designer': '照明設計師',
      'managing_director': '總經理',
      'mechanical_engineer': '機械工程師',
      'mep_engineer': 'MEP 工程師',
      'owner': '業主',
      'owner_representative': '業主代表',
      'planner': '規劃師',
      'plumbing_engineer': '衛工工程師',
      'principal_architect': '首席建築師',
      'process_engineer': '製程工程師',
      'procurement': '採購',
      'procurement_specialist': '採購專員',
      'project_controls_engineer': '專案控管工程師',
      'project_director': '專案總監',
      'project_engineer': '專案工程師',
      'project_leader': '專案主管',
      'project_manager': '專案經理',
      'purchasing_coordinator': '採購協調員',
      'quality_manager': '品質經理',
      'quantity_surveyor': '工料測量師',
      'real_estate_manager': '房地產經理',
      'risk_engineer': '風險工程師',
      'risk_manager': '風險經理',
      'safety_manager': '安全經理',
      'scheduler': '計畫員',
      'self_perform_foreman': '自行承包工頭',
      'services_engineer': '維修工程師',
      'site_engineer': '工地工程師',
      'site_manager': '工地管理員',
      'site_supervisor': '工地主管',
      'structural_engineer': '結構工程師',
      'subcontractor': '分包商',
      'superintendent': '主管機關',
      'surveyor': '測量員',
      'team_leader': '團隊主管',
      'transportation_engineer': '運輸工程師',
      'vdc_engineer': 'VDC 工程師',
      'vdc_manager': 'VDC 管理員',
      'vp_quality': 'VP 品質',
      'vp_safety': 'VP 安全'
    }
  }
};
export default locales;